import { authenticationService, getSessionVersion } from "@/core/services";
import { retrieveMe } from "@sgdf/client-v2";
import type { MeetingRoleOut } from "@sgdf/client-v2";
import { apiCall } from "@/core/utils/api";
import { useQuery } from "@tanstack/vue-query";

export const useMe = () => {
  const userStore = useUserStore();
  const { meId } = storeToRefs(userStore);

  if (!meId.value) {
    const version = getSessionVersion();
    authenticationService.getUser().then((user) => {
      if (user?.id && version === getSessionVersion()) {
        userStore.setMeId(user.id);
      }
    });
  }

  return meId;
};

export const useMeDetails = () => {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => apiCall(retrieveMe()),
    staleTime: Infinity,
  });
};

export interface UserRole {
  isDirector: boolean;
  isFormer: boolean;
  isIntern: boolean;
  isSuperuser: boolean;
  detail: MeetingRoleOut | null;
}

export const useMyParticipation = () => {
  const meetingId = useMeetingId();
  const { data, refetch: internalRefetch, ...rest } = useMeDetails();
  const participation = computed(() => {
    if (meetingId.value && data.value && data.value.participations) {
      return data.value.participations.find(
        (p) => p.meeting_id === meetingId.value,
      );
    }
  });

  const diplomas = computed(() => data.value?.diplomas);
  const isLoading = computed(() => rest.isLoading.value);

  const refetch = async () => {
    const { data: internalData, ...refetchRest } = await internalRefetch();

    if (meetingId.value && internalData && internalData.participations) {
      const currentParticipation = internalData.participations.find(
        (p) => p.meeting_id === meetingId.value,
      );
      return {
        participation: currentParticipation,
        diplomas: internalData.diplomas,
        ...refetchRest,
      };
    }
  };

  return {
    participation,
    refetch,
    diplomas,
    ...rest,
    isLoading,
  };
};
